import { render } from "./ScrollTopArrow.vue?vue&type=template&id=cd8d290a"
import script from "./ScrollTopArrow.vue?vue&type=script&lang=js"
export * from "./ScrollTopArrow.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__